import { render, staticRenderFns } from "./WordButton.vue?vue&type=template&id=64ca1c7c&scoped=true&"
import script from "./WordButton.vue?vue&type=script&lang=js&"
export * from "./WordButton.vue?vue&type=script&lang=js&"
import style0 from "./WordButton.vue?vue&type=style&index=0&id=64ca1c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca1c7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
